import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Settings, Save } from 'lucide-react';

export function TokenInstructionsCard({ instructions, setInstructions, onSave, saving, readOnly = false }) {
  return (
    <Card className="border-border bg-card">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
          <Settings className="w-5 h-5 text-purple-500" />
          Istruzioni Token
        </CardTitle>
        <CardDescription>
          {readOnly 
            ? 'Istruzioni per gli utenti su come trovare il token.'
            : 'Scrivi le istruzioni che gli utenti vedranno per trovare il token da inserire per aggiungere un link. Supporta testo formattato.'}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Textarea
          rows={8}
          placeholder="Inserisci qui le istruzioni per gli utenti su come trovare il token..."
          value={instructions}
          onChange={(e) => !readOnly && setInstructions(e.target.value)}
          data-testid="token-instructions-input"
          className={`text-sm ${readOnly ? 'bg-muted' : ''}`}
          disabled={readOnly}
        />
        {!readOnly && (
          <Button
            onClick={onSave}
            disabled={saving}
            data-testid="save-token-instructions"
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            <Save className="w-4 h-4 mr-2" />
            {saving ? 'Salvataggio...' : 'Salva Istruzioni'}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
